/**
 * Created by thomasmark on 28.03.18.
 */

export function resetApp() {
    return {
        type: "RESET_APP",
        payload: null
    }
}

export function resetContainer() {
    return {
        type: "RESET_CONTAINER",
        payload: null
    }
}

// Funktion wird nicht mehr gebraucht
// Siehe index.js / useLayoutEffect()
export function resizeMain(source) {
    return {
        type: "RESIZE_MAIN",
        payload: source
    }
}

export function setApiURL(apiUrl) {
    return {
        type: "SET_API_URL",
        payload: apiUrl
    }
}

export function setAppModus(modus) {
    return {
        type: "SET_APP_MODUS",
        payload: modus
    }
}

export function setAppPreview(flag) {
    return {
        type: "SET_APP_PREVIEW",
        payload: flag
    }
}

export function setOnline(flag) {
    return {
        type: "SET_ONLINE",
        payload: flag
    }
}

export function setGroupPos(pos) {
    return {
        type: "SET_GROUP_POS",
        payload: pos
    }
}

export function setPageIndex(index) {
    return {
        type: "SET_PAGE_INDEX",
        payload: index
    }
}

export function setGalleryIndex(index) {
    return {
        type: "SET_GALLERY_INDEX",
        payload: index
    }
}

export function setGalleryImages(images) {
    return {
        type: "SET_GALLERY_IMAGES",
        payload: images
    }
}

export function setGalleryTimestamp(ts) {
    return {
        type: "SET_GALLERY_TIMESTAMP",
        payload: ts
    }
}

export function setSearchImagesOnly(flag) {
    return {
        type: "SET_SEARCH_IMAGES_ONLY",
        payload: flag
    }
}

export function setGallerySearch(flag) {
    return {
        type: "SET_GALLERY_SEARCH",
        payload: flag
    }
}

export function setGalleryGroup(index) {
    return {
        type: "SET_GALLERY_GROUP",
        payload: index
    }
}

export function setDialogType(type) {
    return {
        type: "SET_DIALOG_TYPE",
        payload: type
    }
}

export function setModalDialog(dialog, type = null, details = null) {
    return {
        type: "SET_MODAL_DIALOG",
        payload: { dialog, type, details }
    }
}

export function closeModalDialog() {
    return {
        type: "SET_MODAL_DIALOG",
        payload: { dialog: null, type: null, details: null }
    }
}

export function setToolbarType(type) {
    return {
        type: "SET_TOOLBAR_TYPE",
        payload: type
    }
}

export function setFieldEdit(id) {
    return {
        type: "SET_FIELD_EDIT",
        payload: { id: id }
    }
}

export function setGridEdit(flag) {
    return {
        type: "SET_GRID_EDIT",
        payload: flag
    }
}

export function setGridEditType(flag) {
    return {
        type: "SET_GRID_EDIT_TYPE",
        payload: flag
    }
}

export function setCoverEdit(flag) {
    return {
        type: "SET_COVER_EDIT",
        payload: flag
    }
}

export function setContentJSON(productList, tagList) {
    return {
        type: "SET_SYNC_JSON",
        payload: { productList: productList, tagList: tagList }
    }
}

export function setFilterVisible(flag) {
    return {
        type: "SET_FILTER_VISIBLE",
        payload: flag
    }
}

export function setFilterIndex(index) {
    return {
        type: "SET_FILTER_INDEX",
        payload: index
    }
}

export function setFilterList(list) {
    return {
        type: "SET_FILTER_LIST",
        payload: list
    }
}

export function setFavoredList(list) {
    return {
        type: "SET_FAVORED_LIST",
        payload: list
    }
}

export function setFavoredIndex(index, path) {
    return {
        type: "SET_FAVORED_INDEX",
        payload: { index: index, path: path }
    }
}

export function setSearchIndex(index, path) {
    return {
        type: "SET_SEARCH_INDEX",
        payload: { index: index, path: path }
    }
}

export function setSearchString(search) {
    return {
        type: "SET_SEARCH_STRING",
        payload: search
    }
}

export function setPath(path) {
    return {
        type: "SET_PATH",
        payload: path
    }
}

export function setCustomLayout(layout) {
    return {
        type: "SET_CUSTOM_LAYOUT",
        payload: layout
    }
}

export const setToken = (token) => {
    return {
        type: "SET_TOKEN",
        payload: token
    }
}

export const setPortfoliosReady = (flag) => {
    return {
        type: "SET_PORTFOLIOS_READY",
        payload: flag
    }
}

export const setContainersReady = (flag) => {
    return {
        type: "SET_CONTAINERS_READY",
        payload: flag
    }
}

export function setCurrentContainer(container) {
    return {
        type: "SET_CURRENT_CONTAINER",
        payload: container
    }
}

export function setCurrentContainerTitle(title) {
    return {
        type: "SET_CURRENT_CONTAINER_TITLE",
        payload: title
    }
}

export function setImageBuffer(imageBuffer) {
    return {
        type: "SET_ALL_IMAGES",
        payload: imageBuffer
    }
}
